import type * as pf from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import { ut_joinPathParts } from '@base/utils/utils'

export function fn_copyParam(sourceAr: any, destAr: any, defaultAr: any, key: string, setEmpty: boolean = false, noEmpty: boolean = false) {
  if ((sourceAr[key] !== undefined) && !(noEmpty && !sourceAr[key])) {
    destAr[key] = sourceAr[key]
    // set(destAr, key, sourceAr[key]);
  }
  else if (setEmpty) {
    let value
    if (typeof defaultAr[key] === 'string') {
      value = ''
    }
    else if (typeof defaultAr[key] === 'boolean') {
      value = false
    }
    destAr[key] = value
    // set(destAr, key, value);
  }
}

export function fn_getNewRouterParams(param: tp.IParamRouter, path: string, paramData: tp.IParamData, queryAddType?: tp.IQueryAddType): tp.IParamRouter {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Modify strip path
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  let newPath: string = param.path || path
  newPath = decodeURI(newPath)

  // strip path with fix rcco, lcda, root
  const embeddedInfo: tp.IParamEmbedInfo = paramData.embeddedInfo || {}

  if (embeddedInfo.hidcountry || embeddedInfo.hidlanguage || embeddedInfo.hidstartpath) {
    const basePath: string = embeddedInfo.basepath ? decodeURI(embeddedInfo.basepath) : ''
    if (basePath) {
      // basepath and newpath are always with leading slash direct compare
      if ((newPath).indexOf(basePath) === 0) {
        newPath = newPath.substring(basePath.length)
      }
    }

    // Delete leading slash from newpath otherwise split will have empty first index
    newPath = newPath.startsWith('/') ? newPath.substring(1) : newPath
    const splitPath = newPath.split('/')

    if (embeddedInfo.hidstartpath) {
      // hidstartpath can be more than 1 path splice whole
      const splitRoot = embeddedInfo.hidstartpath.split('/')
      splitPath.splice(2, splitRoot.length)
    }
    if (embeddedInfo.hidlanguage) {
      splitPath.splice(1, 1)
    }
    if (embeddedInfo.hidcountry) {
      splitPath.splice(0, 1)
    }

    const embeddedPath: string[] = (basePath || '').split('/') || []
    newPath = '/' + ut_joinPathParts([...embeddedPath, ...splitPath]) // absolute path
  }

  // If path is empty set a slash otherwise router is not working
  newPath = newPath || '/'

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // Get new query
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  const newQuery: tp.IParamQuery = {}

  // global params
  fn_addParam(param, paramData, newQuery, 'rcre1', !queryAddType?.noGlobalParams, false)
  fn_addParam(param, paramData, newQuery, 'rcre2', !queryAddType?.noGlobalParams, false)
  fn_addParam(param, paramData, newQuery, 'rcst', !queryAddType?.noGlobalParams, false)
  fn_addParam(param, paramData, newQuery, 'stage', !queryAddType?.noGlobalParams, false)
  fn_addParam(param, paramData, newQuery, 'date', !queryAddType?.noGlobalParams, false)
  fn_addParam(param, paramData, newQuery, 'rawurl', !queryAddType?.noGlobalParams, false)
  fn_addParam(param, paramData, newQuery, 'dops', !queryAddType?.noGlobalParams, false)

  // page dependent params
  fn_addParam(param, paramData, newQuery, 'sort', !queryAddType?.noPageParams, false)
  fn_addParam(param, paramData, newQuery, 'term', !queryAddType?.noPageParams, false)

  // psx
  fn_addParam(param, paramData, newQuery, 'psx', !queryAddType?.noPsx, false)

  // Disabled columns belong to the same page context as the filter — a link that drops psx drops dcl too.
  fn_addParam(param, paramData, newQuery, 'dcl', !queryAddType?.noPsx, false)

  // Tab
  fn_addParam(param, paramData, newQuery, 'tab', !queryAddType?.noTab, true)
  fn_addParam(param, paramData, newQuery, 'tab2', !queryAddType?.noTab, true)

  // special params
  fn_addParam(param, paramData, newQuery, 'param1', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param2', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param3', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param4', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param5', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param6', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param7', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param8', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param9', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param10', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param11', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param12', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param13', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param14', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param15', !queryAddType?.noCustom, true)
  fn_addParam(param, paramData, newQuery, 'param16', !queryAddType?.noCustom, true)

  fn_addParam(param, paramData, newQuery, 'embedded', !queryAddType?.noCustom, true)

  // paging
  if (param.query.page) {
    if (Number(param.query.page) > 1) {
      newQuery.page = param.query.page
    }
  }

  // Tab old way
  /* if (param.query.tab) {
    newQuery.tab = param.query.tab;
  }
  else if (!queryAddType?.noTab && paramData.tab) {
    newQuery.tab = paramData.tab;
  } */

  // Temporary params only add if set
  if (param.query.q) { newQuery.q = param.query.q + (Math.floor(Math.random() * 100000) + 1).toString() } // everything else meta, login ...
  if (param.query.forceloading) { newQuery.forceloading = param.query.forceloading + (Math.floor(Math.random() * 100000) + 1).toString() } // force loading

  // return new path, query and hash if is set
  return {
    path: newPath,
    query: newQuery,
    hash: param.hash,
  }
}

function fn_addParam(param: tp.IParamRouter, paramData: any, newQuery: tp.IParamQuery, key: keyof tp.IParamQuery, useParamData: boolean, customerParam: boolean) {
  if (!useParamData) {
    if (param.query[key]) { newQuery[key] = param.query[key] || '' }
  }
  else {
    if (paramData.queryUrlServer && !customerParam) {
      if (param.query[key] === undefined && paramData.queryUrlServer[key]) {
        newQuery[key] = paramData.queryUrlServer[key]
      }
      else if (param.query[key]) {
        newQuery[key] = param.query[key]
      }
    }
    else if (customerParam) {
      if (param.query[key] === undefined && paramData[key]) {
        newQuery[key] = typeof paramData[key] === 'object' ? JSON.stringify(paramData[key]) : paramData[key]
      }
      else if (param.query[key]) {
        newQuery[key] = typeof param.query[key] === 'object' ? JSON.stringify(param.query[key]) : param.query[key]
      }
    }
  }
}

// get node by path, take either PSM or nodeName
export function fn_getNodesByPath(node: pf.TPfNode, pathAr: string[], includesProp: boolean): { resNode: pf.TPfNode, resPathAr: string[] } {
  while (pathAr.length > (includesProp ? 1 : 0)) {
    const nodes = node.nodes
    if (nodes) {
      const pindex: number = nodes.findIndex(n => n.attrs?.PSM === pathAr[0] || n.nodeName === pathAr[0])
      if (pindex > -1) {
        pathAr.shift()
        if (nodes[pindex]) {
          node = nodes[pindex]
        }
      }
      else {
        break
      }
    }
    else {
      break
    }
  }
  return { resNode: node, resPathAr: pathAr }
}
